import { AbstractCommand } from 'src/models/command';

class DelayTheTaskOneWeekCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_DelayTheTaskOneWeek';

	public constructor(aggregateId: string) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
		};
	}
}

export { DelayTheTaskOneWeekCommand };
